import React, { useMemo } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { useAssetTypeImageTypes } from "../../hooks";
import useImageTypes from "./useImageTypes";
import { useTranslation } from "react-i18next";
import styles from "./styles";
import AppModal from "../AppModal";

import {
    MenuItem,
    Select,
    Button,
    InputLabel,
    FormControl,
    Box,
} from "@mui/material/";

type Props = {
    assetTypeId: number,
    exclusionReasonTypeId: number,
    onChange: Function,
    onDelete: Function,
    onHide: Function,
    photo: any,
    visible: boolean,
};

/**
 * Photo List Photo Modal Component
 */
export default ({
    assetTypeId,
    exclusionReasonTypeId,
    onChange,
    onDelete,
    onHide,
    photo,
    visible,
}: Props) => {
    const { t } = useTranslation();
    const assetImageTypes = useAssetTypeImageTypes(assetTypeId);
    const imageTypes = useImageTypes(assetImageTypes, exclusionReasonTypeId);
    const classes = makeStyles(styles)();

    const imageType = useMemo(() => {
        if (photo && imageTypes.length) {
            return imageTypes.find((item) => item.id === photo.imageType);
        }
        return null;
    }, [imageTypes, photo]);

    const onImageTypeChange = (e: any) => {
        const { value } = e.target;
        const next = { ...photo, imageType: value };
        onChange && onChange(next);
    };

    const onPhotoDelete = () => {
        onDelete && onDelete(photo);
        onHide && onHide();
    };

    return (
        <AppModal
            isVisible={visible}
            onClose={onHide}
            onDialogClose={onHide}
            title={"Editing image"}
        >
            {Boolean(photo) && imageType && (
                <div className={classes.modal}>
                    <Box className={classes.padding}>
                        <FormControl fullWidth>
                            <InputLabel id="image-type-select-label">
                                {t("imageType")}
                            </InputLabel>
                            <Select
                                id="image-type-select"
                                value={imageType.id}
                                label={t("imageType")}
                                onChange={onImageTypeChange}
                                data-testid={"picker"}
                            >
                                {imageTypes.map((item, index) => (
                                    <MenuItem
                                        value={item.id}
                                        key={index}
                                        className={classes.menuItem}
                                    >
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <div className={classes.previewWrp}>
                            <img
                                src={photo.image}
                                className={classes.imagePreview}
                            />
                        </div>
                    </Box>

                    <Box className={classes.padding}>
                        <Button
                            fullWidth
                            onClick={onPhotoDelete}
                            variant="outlined"
                            color="primary"
                        >
                            {t("deletePhoto")}
                        </Button>
                    </Box>
                </div>
            )}
        </AppModal>
    );
};
